import * as types from '../mutation-types'
import { api } from '@/modules/api'
import saveFileFromBase64 from '@/utils/saveFileFromBase64'

const state = () => ({
  invoices: null,
  totalPages: 0,
  totalItems: 10
})

const getters = {
  getInvoices: state => state.invoices,
  getTotalItemsInvoices: state => state.totalItems,
  getCounterInvoices: state => state.totalPages
}

const actions = {
  async fetchInvoices ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.invoices.get(payload))
      commit(types.SET_INVOICE_LIST, data)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail on fetch invoices')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async resendInvoices ({ commit }, paymentProviderTransactionId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.invoices.resend(), { paymentProviderTransactionId })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invoices was resend email')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail on resend invoices')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async resendIPN ({ commit }, paymentProviderTransactionId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.invoices.resendIPN(paymentProviderTransactionId))
      commit(types.CREATE_SUCCESS_MESSAGE, 'IPN was resend')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail to resend IPN')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async downloadInvoicePDF ({ commit }, {id, name}) {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.invoices.downloadPDF(id),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, `${name} invoice PDF`, 'pdf')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invoices was Exported PDF')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Invoices wasn\'t Exported PDF')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async downloadInvoicesExcel ({ commit }, ids) {
    try {
      const payload = {}
      payload.paymentProviderTransactionsIds = ids
      const { data } = await this.$axios({
        method: 'post',
        url: api.invoices.downloadExcel(),
        data: payload,
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'InvoicesZIP', 'zip')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invoices was Exported ZIP')
    } catch (err) {
      throw err
    }
  },
  async downloadIPNpdf ({ commit }, {id, name}) {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.invoices.downloadIPNpdf(id),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, `${name} IPN`, 'pdf')
      commit(types.CREATE_SUCCESS_MESSAGE, 'IPN was exported')
    } catch (err) {
      throw err
    }
  }
}

const mutations = {
  [types.SET_INVOICE_LIST] (state, { invoices, totalItems, totalPages }) {
    state.invoices = invoices
    state.totalItems = totalItems
    state.totalPages = totalPages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js